( function( $ ){

    if( ! $( '.category-top-5' ).length ){
        return;
    }

    let map_object;

    // Setup the map
    function init_map(){

        let map_element     =  document.getElementById( 'top-5s-map' );
        let options         = {
            center: {lat: 43.68, lng: -79.43},
            zoom: 13,
            mapTypeControl: false,
            streetViewControl: false,
            fullscreenControl: false
        };

        map_object      = new google.maps.Map( map_element, options );
        if( navigator.geolocation ){
            navigator.geolocation.getCurrentPosition( (position) => {
                let location   = new google.maps.LatLng( position.coords.latitude, position.coords.longitude );
                map_object.setCenter( location );
                get_places();
            });
        }
        else{
            get_places();
        }

    }

    // Get places for map display
    function get_places(){
        $( '#top-5s-map' ).loadingScreen( true );
        ThemeJS.Functions.send_ajax_request({
            data: {
                center: {
                    lat: map_object.getCenter().lat(),
                    lng: map_object.getCenter().lng()
                },
                nearby: $( '#top5-select-nearby' ).val(),
                distance: $( '#top5-select-distance' ).val(),
                place_type: $( '#top5-select-place-types' ).val(),
                action: 'top5-search'
            },
            success: (res) => {
                console.log( res );
                $( '#top-5s-map' ).loadingScreen( false );
            },
            error: (res) => {
                console.log( res );
            }
        });
    }

    // Listeners
    $( document ).ready( () => {
        init_map();
    });

})( jQuery );